var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#323657",
    d: "M15.188 5.063H9.233l-1.92-1.92a1.12 1.12 0 0 0-.796-.33H2.812a1.125 1.125 0 0 0-1.124 1.125v10.168a1.083 1.083 0 0 0 1.08 1.082H15.25a1.064 1.064 0 0 0 1.063-1.063V6.188a1.125 1.125 0 0 0-1.125-1.125m-8.67-1.125 1.124 1.125h-4.83V3.938zm8.67 10.125H2.813V6.188h12.375z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#323657",
    d: "M11.208 10.035a.562.562 0 0 0-.918-.183l-.727.728V8.438a.563.563 0 1 0-1.125 0v2.142l-.727-.728a.563.563 0 1 0-.796.796l1.687 1.688a.56.56 0 0 0 .796 0l1.688-1.688a.56.56 0 0 0 .122-.613"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFolder);
export default __webpack_public_path__ + "static/media/UploadFolder.47a33f17438110e358ac2d4810ef66ae.svg";
export { ForwardRef as ReactComponent };